import React from 'react';
import { useTranslation } from "next-i18next";
import styles from './Comments.module.scss';
import Link from 'next/link';
// import hooks from "./commentsHooks";
function CommentsData(props) {
    // const { posts_like_dislike, like_dislike, translate } = hooks(props);
    const { t } = useTranslation();
    console.log(props.comment_count,'props.comment_count');
    
    return (
        <div className="d-flex align-center comment-bottom-icons">
            <div className="d-flex">
                <div className={styles.comments_info}>
                    <div className={"d-flex dislike"}>
                        <i className="icon-heart" onClick={() => {
                            // if (props.token) {
                            // posts_like_dislike(props.token)
                            props?.onClick?.()
                            // }
                        }}></i>
                    </div>
                    <span className={styles.comments_info_count}>
                        {props.like_count}
                    </span>
                </div>
                {props.comment_count > 0 && (
                    <Link as={`/${props.language}/${props.id}`} href={`/${props.language}/${props.id}`}>
                        <a className={styles.comments_info}>
                            <i className="icon-chat_1"></i>
                            <span className={styles.comments_info_count}>
                            {props.comment_count}
                        </span>
                        </a>
                    </Link>)}

                {props?.order_count>0 && <div className={styles.comments_info}>
               <i className="icon-testimonials1"></i><div className={styles.comments_info_count}>{props?.order_count} {t('order')}</div>
             </div>}

            </div>

        

        </div>
    )
}
export default CommentsData;
